export default "__VITE_ASSET__14990ddf__"